var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCancelButton2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 3,
    fill: "#BBC2D3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5938 9.875H13.132C12.7085 9.875 12.3117 10.0627 12.0429 10.3909L8.10574 15.2034C7.96475 15.376 7.96475 15.6241 8.10574 15.7966L12.0434 20.6096C12.3117 20.9373 12.7086 21.125 13.132 21.125H21.5938C22.3692 21.125 23 20.4942 23 19.7187V11.2813C23 10.5058 22.3692 9.875 21.5938 9.875ZM19.4441 17.1809L18.1184 18.5066L16.4375 16.8257L14.7566 18.5066L13.4309 17.1809L15.1118 15.5L13.4309 13.8191L14.7566 12.4934L16.4375 14.1743L18.1184 12.4934L19.4441 13.8191L17.7632 15.5C17.7632 15.5 19.4441 17.1809 19.4441 17.1809Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCancelButton2);
export default __webpack_public_path__ + "static/media/icon-cancel-button-2.a1d59ab018df3e1b179495f59f8571f9.svg";
export { ForwardRef as ReactComponent };